import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var disabledBtn = '.c7n-pro-btn-disabled';
var loadingBtn = '.c7n-pro-btn-loading';
var iconOnlyBtn = '.c7n-pro-btn-icon-only';
var focusedBtn = '.c7n-pro-btn-focused';
var getBtnStyle = function getBtnStyle(color, opts) {
  var raisedColor = opts.raisedColor,
    raisedBgColor = opts.raisedBgColor,
    raisedBorderColor = opts.raisedBorderColor,
    raisedLoadingColor = opts.raisedLoadingColor,
    raisedLoadingBgColor = opts.raisedLoadingBgColor,
    raisedLoadingBorderColor = opts.raisedLoadingBorderColor,
    raisedHoverColor = opts.raisedHoverColor,
    raisedHoverBgColor = opts.raisedHoverBgColor,
    raisedHoverBorderColor = opts.raisedHoverBorderColor,
    raisedActiveColor = opts.raisedActiveColor,
    raisedActiveBgColor = opts.raisedActiveBgColor,
    raisedActiveBorderColor = opts.raisedActiveBorderColor,
    raisedFocusColor = opts.raisedFocusColor,
    raisedFocusBgColor = opts.raisedFocusBgColor,
    raisedFocusBorderColor = opts.raisedFocusBorderColor,
    raisedDisabledColor = opts.raisedDisabledColor,
    raisedDisabledBgColor = opts.raisedDisabledBgColor,
    raisedDisabledBorderColor = opts.raisedDisabledBorderColor,
    flatColor = opts.flatColor,
    flatHoverBgColor = opts.flatHoverBgColor,
    flatActiveColor = opts.flatActiveColor,
    flatActiveBgColor = opts.flatActiveBgColor,
    linkHoverColor = opts.linkHoverColor,
    focusOutline = opts.focusOutline;
  return css([".c7n-pro-btn{&&-", "&-raised{color:", ";background-color:", ";border:0.01rem solid ", ";&:not(", "):not(", "):hover{color:", ";background-color:", ";border-color:", ";}&:not(", "):focus:not(:active),&:not(", ")", ":not(:active){color:", ";background-color:", ";border-color:", ";outline:", ";&:hover{color:", ";background-color:", ";border-color:", ";}}&:not(", "):not(", "):active{color:", ";background-color:", ";border-color:", ";}&", "{color:", ";background-color:", ";border-color:", ";}&", ",&:disabled{color:", ";background-color:", ";border-color:", ";}}&&-", "&-flat{color:", ";&:not(", "):not(", "):hover{background-color:", ";}&:not(", "):focus:not(:active),&:not(", ")", ":not(:active){background-color:", ";}&:not(", "):not(", "):active{color:", ";background-color:", ";}}&-", "&-link{color:", ";&:not(", "):not(", "):hover{color:", ";}&:not(", "):not(", "):active{color:", ";}&:not(", "):focus,&:not(", ")", "{&,&:hover{color:", ";}}}}"], color, raisedColor, raisedBgColor, raisedBorderColor, disabledBtn, loadingBtn, raisedHoverColor, raisedHoverBgColor, raisedHoverBorderColor, loadingBtn, loadingBtn, focusedBtn, raisedFocusColor, raisedFocusBgColor, raisedFocusBorderColor, focusOutline, raisedHoverColor, raisedHoverBgColor, raisedHoverBorderColor, disabledBtn, loadingBtn, raisedActiveColor, raisedActiveBgColor, raisedActiveBorderColor, loadingBtn, raisedLoadingColor, raisedLoadingBgColor, raisedLoadingBorderColor, disabledBtn, raisedDisabledColor, raisedDisabledBgColor, raisedDisabledBorderColor, color, flatColor, disabledBtn, loadingBtn, flatHoverBgColor, loadingBtn, loadingBtn, focusedBtn, flatHoverBgColor, disabledBtn, loadingBtn, flatActiveColor, flatActiveBgColor, color, flatColor, disabledBtn, loadingBtn, linkHoverColor, disabledBtn, loadingBtn, flatActiveColor, loadingBtn, loadingBtn, focusedBtn, flatActiveColor);
};
var buttonStyle = function buttonStyle(props) {
  var cd = getThemeData(props, 'common');
  var bd = getThemeData(props, 'button');
  var btnColors = [{
    color: 'primary',
    opts: {
      // raised
      raisedColor: '#fff',
      raisedBgColor: cd.primary,
      raisedBorderColor: cd.primary,
      raisedLoadingColor: '#fff',
      raisedLoadingBgColor: cd.primary4,
      raisedLoadingBorderColor: cd.primary4,
      raisedHoverColor: '#fff',
      raisedHoverBgColor: cd.primary4,
      raisedHoverBorderColor: cd.primary4,
      raisedActiveColor: '#fff',
      raisedActiveBgColor: cd.primary7,
      raisedActiveBorderColor: cd.primary7,
      raisedFocusColor: '#fff',
      raisedFocusBgColor: cd.primary,
      raisedFocusBorderColor: cd.primary,
      raisedDisabledColor: '#fff',
      raisedDisabledBgColor: cd.titleColor4,
      raisedDisabledBorderColor: cd.titleColor4,
      // flat
      flatColor: cd.primary,
      flatHoverBgColor: cd.primary1,
      flatActiveColor: cd.primary7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.primary4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.primary2)
    }
  }, {
    color: 'default',
    opts: {
      // raised
      raisedColor: cd.titleColor2,
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: cd.primary,
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: cd.primary,
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: cd.primary,
      raisedActiveColor: cd.primary7,
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: cd.primary7,
      raisedFocusColor: cd.titleColor2,
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: cd.primary,
      flatHoverBgColor: cd.primary1,
      flatActiveColor: cd.primary7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.primary4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.primary2)
    }
  }, {
    color: 'red',
    opts: {
      // raised
      raisedColor: cd.redColor6,
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: cd.redColor6,
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: cd.redColor6,
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: cd.redColor6,
      raisedActiveColor: cd.redColor7,
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: cd.redColor7,
      raisedFocusColor: cd.redColor6,
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: cd.redColor6,
      flatHoverBgColor: cd.redColor1,
      flatActiveColor: cd.redColor7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.redColor4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.redColor2)
    }
  }, {
    color: 'gray',
    opts: {
      // raised
      raisedColor: '#d0d0d0',
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: '#d0d0d0',
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: '#d0d0d0',
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: '#d0d0d0',
      raisedActiveColor: '#aba1a1',
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: '#aba1a1',
      raisedFocusColor: '#d0d0d0',
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: '#d0d0d0',
      flatHoverBgColor: '#e6e6e6',
      flatActiveColor: '#aba1a1',
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.titleColor4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.lineColor2)
    }
  }, {
    color: 'blue',
    opts: {
      // raised
      raisedColor: cd.blueColor6,
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: cd.blueColor6,
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: cd.blueColor6,
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: cd.blueColor6,
      raisedActiveColor: cd.blueColor7,
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: cd.blueColor7,
      raisedFocusColor: cd.blueColor6,
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: cd.blueColor6,
      flatHoverBgColor: cd.blueColor1,
      flatActiveColor: cd.blueColor7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.blueColor4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.blueColor2)
    }
  }, {
    color: 'green',
    opts: {
      // raised
      raisedColor: cd.greenColor6,
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: cd.greenColor6,
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: cd.greenColor6,
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: cd.greenColor6,
      raisedActiveColor: cd.greenColor7,
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: cd.greenColor7,
      raisedFocusColor: cd.greenColor6,
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: cd.greenColor6,
      flatHoverBgColor: cd.greenColor1,
      flatActiveColor: cd.greenColor7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.greenColor4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.greenColor2)
    }
  }, {
    color: 'yellow',
    opts: {
      // raised
      raisedColor: cd.yellowColor6,
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: cd.yellowColor6,
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: cd.yellowColor6,
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: cd.yellowColor6,
      raisedActiveColor: cd.yellowColor7,
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: cd.yellowColor7,
      raisedFocusColor: cd.yellowColor6,
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: cd.yellowColor6,
      flatHoverBgColor: cd.yellowColor1,
      flatActiveColor: cd.yellowColor7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.yellowColor4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.yellowColor2)
    }
  }, {
    color: 'purple',
    opts: {
      // raised
      raisedColor: cd.purpleColor6,
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: cd.purpleColor6,
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: cd.purpleColor6,
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: cd.purpleColor6,
      raisedActiveColor: cd.purpleColor7,
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: cd.purpleColor7,
      raisedFocusColor: cd.purpleColor6,
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: cd.purpleColor6,
      flatHoverBgColor: cd.purpleColor1,
      flatActiveColor: cd.purpleColor7,
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.purpleColor4,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.purpleColor2)
    }
  }, {
    color: 'dark',
    opts: {
      // raised
      raisedColor: '#2f353b',
      raisedBgColor: '#fff',
      raisedBorderColor: cd.lineColor1,
      raisedLoadingColor: '#2f353b',
      raisedLoadingBgColor: '#fff',
      raisedLoadingBorderColor: cd.lineColor1,
      raisedHoverColor: '#2f353b',
      raisedHoverBgColor: '#fff',
      raisedHoverBorderColor: '#2f353b',
      raisedActiveColor: '#0f1214',
      raisedActiveBgColor: '#fff',
      raisedActiveBorderColor: '#0f1214',
      // TODO:
      raisedFocusColor: '#2f353b',
      raisedFocusBgColor: '#fff',
      raisedFocusBorderColor: cd.lineColor1,
      raisedDisabledColor: cd.titleColor3,
      raisedDisabledBgColor: cd.lineColor3,
      raisedDisabledBorderColor: cd.lineColor1,
      // flat
      flatColor: '#2f353b',
      flatHoverBgColor: '#73787a',
      flatActiveColor: '#0f1214',
      flatActiveBgColor: 'transparent',
      // link
      linkHoverColor: cd.titleColor2,
      // other
      height: bd.height,
      minWidth: bd.minWidth,
      minWidthSm: bd.smMinWidth,
      minWidthLg: bd.minWidth,
      focusOutline: "0.02rem solid ".concat(cd.lineColor1)
    }
  }];
  return css(["", ";.c7n-pro-btn{height:", "px;font-size:", "px;box-shadow:none !important;white-space:nowrap;.c7n-ripple{display:none;}&-loading{> .c7n-progress.c7n-progress-loading{height:100%;display:inline-flex;align-items:center;}}&-icon-only", " .c7n-progress.c7n-progress-loading{margin-right:0;}&:focus,&-focused{transition:outline 0ms;}&&-icon-only,&&-icon-only&-sm,&&-icon-only&-lg{width:", "px;height:", "px;font-size:12px;border-radius:0.02rem;> .icon,> button .icon{font-size:", "px;}}&:not(", ") > .icon{margin-right:0.04rem;}&:not(&-icon-only):not(&-link){min-width:", ";&.c7n-pro-btn-sm{min-width:", ";}&.c7n-pro-btn-lg{min-width:", ";}}&-raised{&:not(.c7n-pro-btn-primary):not(", "):not(", "){background-color:#fff;}&:not(", "){padding:0 0.12rem;}}&&-flat{&:not(", "){padding:0 0.08rem;}}&&-flat,&&-link{&.c7n-pro-btn-lg{line-height:1.5;}&", ",&:disabled{color:", ";}}a&{text-decoration:none;}&&-loading,&&-disabled,&&:disabled{opacity:1;}&& .c7n-progress.c7n-progress-loading .c7n-progress-inner circle{stroke:currentColor;}}"], btnColors.map(function (_ref) {
    var color = _ref.color,
      opts = _ref.opts;
    return getBtnStyle(color, opts);
  }), bd.height, bd.fontSize, loadingBtn, bd.height, bd.height, bd.iconFontSize, iconOnlyBtn, bd.minWidth, bd.sMminWidth, bd.minWidth, disabledBtn, loadingBtn, iconOnlyBtn, iconOnlyBtn, disabledBtn, cd.titleColor3);
};
export default css(["", ""], buttonStyle);
/*
  备注：
  1、按钮不区分 size ，统一尺寸
  2、链接按钮仅靠 funcType 区分：raised / flat 按钮使用 href 属性样式不会变成链接按钮
  3、按钮中图标大小为 14px
 */